module.exports = {"host_idp_dev":"https://idp-apigw-dev.cloud.grohe.com/v1/gsc/","host_idp_preprod":"https://idp2-apigw-preprod.cloud.grohe.com/v1/gsc/","host_idp_prod":"https://idp2-apigw.cloud.grohe.com/v1/gsc/"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config/config.json
// module id = +m4T
// module chunks = 0